import { memo, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import { get } from 'lodash'
import api, { customPhotoUploadApi } from '../../../api'
import { useSelector } from 'react-redux'
import customMainApi from '../../../api'
import AllRegions from '../../../json/Regions/regions.json'
import AllDistricts from '../../../json/Regions/districts.json'
import AllVillages from '../../../json/Regions/villages.json'
import ClipLoader from 'react-spinners/ClipLoader'
import { message, Input, Button as AntButton } from 'antd'
import moment from 'moment'
import { ErrorModal, SuccessModal } from '../../../components/Modal'
import Spinner from '../../../components/Spinner'
import { formatPhoneNumber } from '../../../lib/FormatPhoneNumber'
import { FaTrash } from 'react-icons/fa'
const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		height: '90%',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		border: 'none',
		borderRadius: 15,
		overflowX: 'auto',
	},
}

const CustomInput = ({ type, value, onChange, placeholder, onBlur }) => {
	return (
		<div className="flex flex-col gap-2 ng">
			<label className="text-black">{placeholder}</label>
			<input
				type={type}
				className={`border-[1px] border-[#DFE2E9] p-2 rounded-md w-full ${type === 'number' ? 'no-spinner' : ''}`}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				onBlur={onBlur}
			/>

			<style jsx>{`
				.no-spinner {
					-moz-appearance: textfield;
				}
				.no-spinner::-webkit-outer-spin-button,
				.no-spinner::-webkit-inner-spin-button {
					-webkit-appearance: none;
					margin: 0;
				}
			`}</style>
		</div>
	)
}

const UpdateUserModal = ({ clientData, onClose }) => {
	useEffect(() => {
		console.log('clientData ======>>>>>', clientData)
	}, [clientData])
	const { getMe } = useSelector((state) => state.main)

	const errorRef = useRef()
	const succesRef = useRef()
	const [score, setScore] = useState('')
	const [U_Created, setU_Created] = useState('')
	const [passport, setPassport] = useState('')
	const [phoneNumberArray, setPhoneNumberArray] = useState([''])
	const [workplace, setWorkplace] = useState('')
	const [male, setMale] = useState('')
	const [userName, setUserName] = useState('')
	const [userSureName, setUserSureName] = useState('')
	const [userFathersName, setUserFathersName] = useState('')
	const [addresses, setAddress] = useState([])

	const [regions, setRegions] = useState([])
	const [cities, setCities] = useState([])
	const [districts, setDistricts] = useState([])
	const [selectedRegion, setSelectedRegion] = useState({
		Code: '',
		Name: '',
	})
	const [selectedCity, setSelectedCity] = useState({
		Code: '',
		Name: '',
		U_RegionCode: '',
	})
	const [selectedDistrict, setSelectedDistrict] = useState({
		Code: '',
		Name: '',
		U_CityCode: '',
	})
	const [allRegions, setAllRegions] = useState()
	const [allCities, setAllCities] = useState()
	const [allDistricts, setAllDistricts] = useState()

	const [comment, setComment] = useState('')
	const [comment2, setComment2] = useState('')

	const [frozen, setFrozen] = useState('')
	const [userFields, setUserFields] = useState([])
	const [isLoading, setIsLoading] = useState(false)
	const [bpLoading, setBpLoading] = useState(false)
	const [address2, setAddress2] = useState('')
	const [ageData, setAgeData] = useState('')
	const [path, setPath] = useState([])
	const [employeeData, setEmployeeData] = useState([])
	const [language, setLanguage] = useState('')
	const [bornAdress, setBornAdress] = useState('')
	const [salary, setSalary] = useState('')
	const [isPlacesLoading, setIsPlacesLoading] = useState(false)

	const role =
		get(getMe, 'Department2.Name', '') === 'Boshqaruv' ||
		get(getMe, 'Department2.Name', '') === 'Scoring'

	const getEmployess = (id) => {
		try {
			api(`EmployeesInfo(${id})`).then((res) => {
				const data = JSON.parse(res.data)
				setEmployeeData(JSON.parse(res.data))
				setU_Created(
					`${get(data, 'FirstName', '')} ${get(data, 'LastName', '')} `,
				)
			})
		} catch (err) {
			console.error('Error in getting Employees in Active Clients Update', err)
		}
	}

	useEffect(() => {
		;(async () => {
			setBpLoading(true)

			try {
				api(
					`BusinessPartners('${clientData.CardCode}')?$select=CardName,U_Comment,U_PhotoId,U_Salary,U_age_data,FreeText,Frozen,U_workplace,U_Telephone,U_address,U_Respawn,U_Language,U_Gender,U_PS,U_KATM,U_Score,U_MIB,U_Nasiya,U_Created,BPAddresses`,
				).then((res) => {
					const data = JSON.parse(res.data)
					const splittedCardName = data.CardName.split(' ')
					setUserName(splittedCardName[1])
					setUserSureName(splittedCardName[0])
					setUserFathersName(splittedCardName[2])
					const bpAddresses = get(data, 'BPAddresses', [])

					setWorkplace(get(data, 'U_workplace', ''))
					setPhoneNumberArray(data.U_Telephone.split(' , ') || [''])
					setMale(get(data, 'U_Gender', ''))
					setPassport(get(data, 'U_PS', ''))
					setScore(get(data, 'U_Score', ''))
					setSalary(get(data, 'U_Salary', ''))

					setLanguage(get(data, 'U_Language', ''))
					setComment(get(data, 'FreeText', '-'))
					setComment2(get(data, 'U_Comment', ''))
					setAddress2(get(data, 'U_address', ''))
					const ageData = get(data, 'U_age_data', '')
					setAgeData(ageData ? moment(ageData).format('YYYY-MM-DD') : '')
					setAddress(
						Array.isArray(bpAddresses) && bpAddresses.length > 0
							? bpAddresses
							: [
									{
										AddressName: 1,
										RowNum: 0,
										BPCode: clientData.CardCode,
										U_CityCode: '',
										U_DistrictCode: '',
										U_RegionCode: '',
										StreetNo: '',
										BuildingFloorRoom: '',
										U_Apartment: '',
									},
								],
						// :[]
					)

					setBornAdress(get(data, 'U_Respawn', ''))
					setFrozen(get(data, 'Frozen', ''))
					const photoId = get(data, 'U_PhotoId', '')

					const photoPaths = photoId
						? photoId.includes(',')
							? photoId.split(',')
							: [photoId]
						: []

					const initialPath = photoPaths.map((path) => ({
						file: 'not empty',
						has: true,
						path,
						imgLoading: false,
					}))

					const finalPath =
						initialPath.length > 0
							? initialPath
							: [{ file: null, path: '', imgLoading: false }]

					setPath(finalPath)
					if (data?.U_Created) {
						getEmployess(data?.U_Created)
					} else {
						setU_Created('')
					}
				})
			} catch (error) {
				console.error('Error in getting Bp Info in Active CLients', error)
			} finally {
				setBpLoading(false)
			}
		})()
	}, [])

	const handleFileChange = (event, index) => {
		const updatedPath = [...path]
		updatedPath[index].file = event.target.files[0]
		setPath(updatedPath)
	}

	const uploadImg = async (index) => {
		const image = path[index]

		if (!image.file) {
			message.error('Фотография не выбрано')
			return
		}

		const formData = new FormData()
		formData.append('file', image.file)

		const generateRandomKey = () => {
			const characters =
				'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
			let randomKey = ''
			for (let i = 0; i < 16; i++) {
				randomKey += characters.charAt(
					Math.floor(Math.random() * characters.length),
				)
			}
			return randomKey
		}

		const randomKey = generateRandomKey()
		const title = 'YourTitle' // Replace with actual title

		formData.append('Title', title)
		formData.append('Key', randomKey)

		try {
			const updatedPath = [...path]
			updatedPath[index].imgLoading = true
			setPath(updatedPath)

			const res = await customPhotoUploadApi.post('assets/upload', formData, {
				headers: { 'Content-Type': 'multipart/form-data' },
			})

			const { key } = res.data
			updatedPath[index].path = key
			setPath(updatedPath)

			message.success('Успешно загружено!')
		} catch (err) {
			message.error('Ошибка загрузки')
		} finally {
			const updatedPath = [...path]
			updatedPath[index].imgLoading = false
			setPath(updatedPath)
		}
	}

	// View the uploaded image
	const viewImage = async (index) => {
		const image = path[index]

		try {
			const res = await customPhotoUploadApi.get(
				`assets/download/${image.path}`,
				{
					responseType: 'blob',
				},
			)

			const url = window.URL.createObjectURL(
				new Blob([res.data], { type: 'image/png' }),
			)

			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', 'BP.png')
			document.body.appendChild(link)
			link.click()

			document.body.removeChild(link)
			window.URL.revokeObjectURL(url)
		} catch (error) {
			message.error('Ошибка загрузки')
		}
	}

	// Add a new empty row for uploading images
	const addNewRow = () => {
		setPath([...path, { file: null, path: '', imgLoading: false }])
	}

	const deleteImage = async (index) => {
		const image = path[index]
		let url = `BusinessPartners('${clientData.CardCode}')`

		try {
			const res = await customPhotoUploadApi.delete(`assets/${image.path}`)
			const photoId = path
				.map((images) => images.path)
				.filter((p) => p !== image.path) // Correct filter syntax
				.join(',')
			await api.patch(url, {
				U_PhotoId: photoId,
			})

			deleteRow(index) // Remove the image from the state after deletion
			message.success('Успешно удалено!')
		} catch (error) {
			message.error('Ошибка удаления файла')
		}
	}

	// Delete a specific row
	const deleteRow = (index) => {
		setPath(path.filter((_, i) => i !== index))
	}

	const handleAddressChange = (index, field, value) => {
		const newAddresses = addresses.map((address, i) => {
			if (i === index) {
				return { ...address, [field]: value }
			}
			return address
		})
		setAddress(newAddresses)
	}

	const removeAddress = (index) => {
		const newAddresses = addresses.filter((_, i) => i !== index)
		setAddress(newAddresses)
	}
	const addAddress = () => {
		setAddress([
			...addresses,
			{
				region: '',
				district: '',
				village: '',
				U_Street: '',
				U_HouseNumber: '',
				passportAdress: '',
				liveAdress: '',
				U_Apartment: '',
			},
		])
	}

	const submit = () => {
		setIsLoading(true)
		let url = `BusinessPartners('${clientData.CardCode}')`
		const photoId = path
			.map((image) => image.path)
			.filter(Boolean)
			.join(',')

		const data = {
			U_workplace: workplace,
			CardCode: Number(clientData.CardCode),
			CardName: `${userSureName} ${userName} ${userFathersName}`,
			U_Telephone: phoneNumberArray.join(' , '),
			Currency: '##',
			U_Gender: male,
			U_PS: passport,
			U_Respawn: bornAdress,
			Frozen: frozen,
			Valid: frozen === 'tNO' ? 'tYES' : 'tNO',
			U_Created: get(getMe, 'EmployeeID', ''),
			U_Language: language,
			U_Salary: salary,
			U_age_data: ageData,
			U_PhotoId: photoId,
			FreeText: comment,
			U_Comment: comment2,
			BPAddresses: addresses.map((address, idx) => ({
				AddressName: idx + 1,
				RowNum: address.RowNum,
				BPCode: address.BPCode,
				U_CityCode:
					typeof address.U_CityCode === 'number'
						? address.U_CityCode
						: Number(address.U_CityCode?.split(' - ')[1]),
				U_DistrictCode:
					typeof address.U_DistrictCode === 'number'
						? address.U_DistrictCode
						: Number(address.U_DistrictCode?.split(' - ')[1]),
				U_RegionCode:
					typeof address.U_RegionCode === 'number'
						? address.U_RegionCode
						: Number(address.U_RegionCode?.split(' - ')[1]),
				BuildingFloorRoom: address.BuildingFloorRoom,
				StreetNo: address.StreetNo,
				U_Apartment: address.U_Apartment,
			})),
		}

		api
			.patch(url, data)
			.then(() => {
				succesRef.current?.open('Клиент успешно обновлен!')
				// try {
				// 	logsUrl.post('apis', {
				// 		company_name: COMPANY_NAME,
				// 		method: 'patch',
				// 		path: `/BusinessPartners('${cardCode}')`,
				// 		description: 'client update qilish',
				// 		username: `${getMe.FirstName} ${getMe.LastName}, EmployeeID: ${getMe.EmployeeID}`,
				// 		body: JSON.stringify(body),
				// 	})
				// } catch (err) {
				// 	errorRef.current?.open(
				// 		'Bu jarayon logs tarixiga saqlanmadi. Iltimos bu haqida bizga habar bering!',
				// 	)
				// }
				// onUpdated()
				// setIsOpenModal(false)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => setIsLoading(false))
	}

	const userFieldsFn = () => {
		customMainApi
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OCRD'",
				},
				headers: {
					Prefer: 'odata.maxpagesize=100',
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	useEffect(() => {
		userFieldsFn()
	}, [])

	useEffect(() => {
		api.get('U_ADDRESS_REGION').then((res) => {
			const result = JSON.parse(res.data).value
			setRegions(result)
		})
	}, [])

	useEffect(() => {
		if (selectedRegion.Code) {
			api
				.get(
					`U_ADDRESS_CITY?$filter=U_RegionCode eq '${selectedRegion.Code}'`,
					{
						headers: {
							Prefer: 'odata.maxpagesize=100',
						},
					},
				)
				.then((res) => {
					const result = JSON.parse(res.data).value
					setCities(result)
				})
		}
	}, [selectedRegion])

	useEffect(() => {
		if (selectedCity.Code) {
			api
				.get(
					`U_ADDRESS_DISCRTICT?$filter=U_CityCode eq '${selectedCity.Code}'`,
					{
						headers: {
							Prefer: 'odata.maxpagesize=100',
						},
					},
				)
				.then((res) => {
					const result = JSON.parse(res.data).value
					setDistricts(result)
				})
		}
	}, [selectedCity])

	useEffect(() => {
		setIsPlacesLoading(true)

		api
			.get('U_ADDRESS_REGION', {
				headers: {
					Prefer: 'odata.maxpagesize=20',
				},
			})
			.then((res) => {
				const result = JSON.parse(res.data).value
				setAllRegions(result || [])
			})

		api
			.get('U_ADDRESS_CITY', {
				headers: {
					Prefer: 'odata.maxpagesize=300',
				},
			})
			.then((res) => {
				const result = JSON.parse(res.data).value
				setAllCities(result || [])
			})

		api
			.get('U_ADDRESS_DISCRTICT', {
				headers: {
					Prefer: 'odata.maxpagesize=3000',
				},
			})
			.then((res) => {
				const result = JSON.parse(res.data).value
				setAllDistricts(result || [])
			})
	}, [])

	useEffect(() => {
		if (
			typeof allRegions === 'object' &&
			typeof allCities === 'object' &&
			typeof allDistricts === 'object'
		) {
			setIsPlacesLoading(false)
		}
	}, [allRegions, allCities, allDistricts])

	const handleAddPhoneNumber = () => {
		setPhoneNumberArray((prev) => [...prev, ''])
	}
	const handleRemovePhoneNumber = (index) => {
		const updatedPhoneNumbers = phoneNumberArray.filter((_, i) => i !== index)
		setPhoneNumberArray(updatedPhoneNumbers)
	}

	return (
		<Modal
			isOpen={clientData}
			onRequestClose={onClose}
			style={customStyles}
			contentLabel="Example Modal"
			ariaHideApp={false}
		>
			<div className="flex flex-col gap-5 w-[700px] p-8">
				<div className="card">
					<p className="text-xl text-center font-bold text-blue-900 mb-4">
						Изменить клиента
					</p>
					{bpLoading || isPlacesLoading ? (
						<Spinner />
					) : (
						<>
							<div className="flex flex-col gap-5">
								<div className="grid grid-cols-3 gap-2">
									<CustomInput
										type="text"
										value={userSureName}
										onChange={(e) => setUserSureName(e.target.value)}
										placeholder="Фамилия"
									/>
									<CustomInput
										type="text"
										value={userName}
										onChange={(e) => setUserName(e.target.value)}
										placeholder="Имя"
									/>
									<CustomInput
										type="text"
										value={userFathersName}
										onChange={(e) => setUserFathersName(e.target.value)}
										placeholder="Отчество"
									/>
								</div>
								{allRegions &&
									allCities &&
									allDistricts &&
									addresses.map((address, index) => {
										const defaultRegion = allRegions.filter(
											(value) =>
												Number(address.U_RegionCode) === Number(value.Code),
										)

										const defaultCity = allCities.filter(
											(value) =>
												Number(address.U_CityCode) === Number(value.Code),
										)

										const defaultDistrict = allDistricts.filter(
											(value) =>
												Number(address.U_DistrictCode) === Number(value.Code),
										)

										return (
											<div className="flex flex-col gap-5 mt-4" key={index}>
												<p className="text-lg text-center font-bold text-black">
													{addresses.length === 1
														? 'Адрес прописки'
														: 'Адрес проживание'}
												</p>
												<div className="flex flex-col sm:flex-row items-center gap-2">
													<div className="flex  flex-col gap-2 items-start w-full">
														<p>Область</p>
														<input
															type="text"
															placeholder="Область"
															list="region"
															defaultValue={
																defaultRegion.length
																	? defaultRegion[0].Name
																	: ''
															}
															onChange={(v) => {
																setSelectedRegion({
																	Code: v.target.value.split(' - ')[1],
																	Name: v.target.value.split(' - ')[0],
																})

																handleAddressChange(
																	index,
																	'U_RegionCode',
																	v.target.value,
																)
															}}
															className={
																'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full sm:w-auto'
															}
															disabled={!role}
														/>
														<datalist id="region">
															{regions.map((v, i) => (
																<option
																	key={i}
																	value={`${v.Name} - ${v.Code}`}
																/>
															))}
														</datalist>
													</div>
													<div className="flex flex-col items-start w-full gap-2">
														<p>Город | Район</p>
														<input
															type="text"
															placeholder="Город | Район"
															list="village"
															defaultValue={
																defaultCity.length ? defaultCity[0].Name : ''
															}
															onChange={(v) => {
																setSelectedCity({
																	Code: v.target.value.split(' - ')[1],
																	Name: v.target.value.split(' - ')[0],
																	U_RegionCode: selectedRegion.Code,
																})
																handleAddressChange(
																	index,
																	'U_CityCode',
																	v.target.value,
																)
															}}
															className={
																'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full sm:w-auto'
															}
															disabled={!role}
														/>
														<datalist id="village">
															{cities.map((v, i) => (
																<option
																	key={i}
																	value={`${v.Name} - ${v.Code}`}
																/>
															))}
														</datalist>
													</div>
													<div className="flex flex-col gap-2 items-start w-full">
														<p>QFY | MFY</p>
														<input
															type="text"
															placeholder="QFY | MFY"
															list="district"
															defaultValue={
																defaultDistrict.length
																	? defaultDistrict[0].Name
																	: ''
															}
															onChange={(v) => {
																setSelectedDistrict({
																	Code: v.target.value.split(' - ')[1],
																	Name: v.target.value.split(' - ')[0],

																	U_CityCode: selectedCity.Code,
																})
																handleAddressChange(
																	index,
																	'U_DistrictCode',
																	v.target.value,
																)
															}}
															disabled={!role}
															className={
																'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full sm:w-auto'
															}
														/>
														<datalist id="district">
															{districts.map((v, i) => (
																<option
																	key={i}
																	value={`${v.Name} - ${v.Code}`}
																/>
															))}
														</datalist>
													</div>
												</div>
												<div className="flex items-center gap-2 w-full flex-col sm:flex-row">
													<CustomInput
														value={address.StreetNo}
														type="text"
														placeholder="Название улицы"
														onChange={(e) => {
															handleAddressChange(
																index,
																'StreetNo',
																e.target.value,
															)
														}}
													/>
													<CustomInput
														value={address.BuildingFloorRoom}
														type="text"
														placeholder="Номер дома"
														onChange={(e) => {
															handleAddressChange(
																index,
																'BuildingFloorRoom',
																e.target.value,
															)
														}}
													/>
													<CustomInput
														value={address.U_Apartment}
														type="text"
														placeholder="Номер квартиры"
														onChange={(e) => {
															handleAddressChange(
																index,
																'U_Apartment',
																e.target.value,
															)
														}}
													/>
												</div>
												{index !== 0 && (
													<button
														onClick={() => removeAddress(index)}
														className="mt-2 bg-red-500 text-white p-2 rounded-md"
													>
														Возврат адреса
													</button>
												)}
												{addresses.length !== index + 1 && (
													<div className="w-full bg-black h-[1px]" />
												)}
											</div>
										)
									})}
								<div className="flex justify-center">
									<button
										onClick={addAddress}
										className="bg-blue-500 text-white p-2 rounded-md w-fit"
									>
										Добавить новый адрес
									</button>
								</div>
								<div className="flex flex-col gap-2">
									{phoneNumberArray.length &&
										phoneNumberArray.map((phone, index) => (
											<div
												className="flex flex-row gap-2 items-end"
												key={index}
											>
												<div className="flex-1">
													<CustomInput
														value={phone}
														onChange={(e) => {
															const rawValue = e.target.value.replace(/\D/g, '')
															if (rawValue.length <= 12) {
																const formattedValue =
																	formatPhoneNumber(rawValue)
																const updatedPhoneNumbers = [
																	...phoneNumberArray,
																]
																updatedPhoneNumbers[index] = formattedValue
																setPhoneNumberArray(updatedPhoneNumbers)
															}
														}}
														type="tel"
														placeholder="Телефон номер"
													/>
												</div>
												{index === phoneNumberArray.length - 1 && (
													<AntButton
														onClick={handleAddPhoneNumber}
														className="h-10 w-fit rounded-lg bg-[#0A4D68] text-white"
													>
														+
													</AntButton>
												)}
												{phoneNumberArray.length > 1 && (
													<AntButton
														onClick={() => handleRemovePhoneNumber(index)}
														className="h-10 w-fit rounded-lg bg-red-500 text-white"
													>
														<FaTrash />
													</AntButton>
												)}
											</div>
										))}
									<textarea
										placeholder="Комментарий"
										className={
											'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '
										}
										value={comment2}
										onChange={(v) => setComment2(v.target.value)}
									/>
									<div className="flex gap-4 justify-center mt-2">
										<div className="flex gap-1 items-center">
											<input
												type="radio"
												id="male"
												name="fav_language"
												value="Male"
												checked={male === 'Male'}
												onChange={(v) => setMale(v.target.value)}
											/>
											<label htmlFor="male">Мужчина</label>
										</div>
										<div className="flex gap-1 items-center">
											<input
												type="radio"
												id="female"
												name="fav_language"
												value="Female"
												checked={male === 'Female'}
												onChange={(v) => setMale(v.target.value)}
											/>
											<label htmlFor="female">Женщина</label>
										</div>
									</div>
								</div>
							</div>

							<div className="mt-10">
								{path.map((image, index) =>
									image.has ? (
										image.path && (
											<div
												key={index}
												className="flex w-full items-start flex-col gap-1 mt-5 mb-10"
											>
												<div>
													<p className="font-bold">Фото-{index + 1}</p>
												</div>
												<div className="flex flex-col sm:flex-row items-center gap-3 w-full">
													<AntButton
														onClick={() => viewImage(index)}
														className="h-10 w-full sm:w-[100px] rounded-lg bg-[#0A4D68] text-white"
													>
														Скачать
													</AntButton>
													<AntButton
														onClick={() => deleteImage(index)}
														disabled={!role}
														className="h-[40px] w-full sm:w-[150px] rounded-lg p-2 bg-red-500 text-white"
													>
														Удалить
													</AntButton>
													{index === path.length - 1 && (
														<AntButton
															onClick={addNewRow}
															disabled={!role}
															className="h-10 w-full  sm:w-[100px] rounded-lg bg-[#0A4D68] text-white"
														>
															Добавить
														</AntButton>
													)}
												</div>
											</div>
										)
									) : (
										<div
											key={index}
											className="flex w-full items-start flex-col  gap-1 mt-5 mb-10"
										>
											<div>
												<p className="font-bold">Фото-{index + 1}</p>
											</div>
											<div className="flex flex-col sm:flex-row items-center gap-3 w-full">
												<Input
													type="file"
													onChange={(e) => handleFileChange(e, index)}
													className="w-full"
													disabled={!role}
												/>
												<AntButton
													onClick={() => uploadImg(index)}
													isLoading={image.imgLoading}
													disabled={!role}
													className="h-10 w-full sm:w-[100px] rounded-lg bg-[#0A4D68] text-white"
												>
													Загрузить
												</AntButton>
												{image.path && (
													<>
														<AntButton
															onClick={() => viewImage(index)}
															className="h-10 w-full sm:w-[100px] rounded-lg bg-[#0A4D68] text-white"
														>
															Скачать
														</AntButton>
														<AntButton
															onClick={() => deleteImage(index)}
															disabled={!role}
															className="h-[40px] w-full sm:w-[150px] rounded-lg p-2 bg-red-500 text-white"
														>
															Удалить
														</AntButton>
													</>
												)}
												{index !== 0 && (
													<AntButton
														onClick={() => deleteRow(index)}
														disabled={!role}
														className="h-10 w-full sm:w-[100px] rounded-lg p-2 bg-red-500 text-white"
													>
														Отмена
													</AntButton>
												)}
												{index === path.length - 1 && (
													<AntButton
														onClick={addNewRow}
														disabled={!role}
														className="h-10 w-full sm:w-[100px] rounded-lg bg-[#0A4D68] text-white"
													>
														Добавить
													</AntButton>
												)}
											</div>
										</div>
									),
								)}
							</div>

							{role ? (
								<div className="flex items-center justify-between">
									<AntButton
										className="bg-red-500 h-10 text-white py-2 px-4 rounded-md w-full sm:w-auto"
										onClick={() => {
											onClose()
										}}
									>
										Нет
									</AntButton>
									<AntButton
										className="bg-[#0A4D68] h-10 text-white py-2 px-4 rounded-md  w-full sm:w-auto"
										loading={isLoading}
										onClick={submit}
									>
										Да
									</AntButton>
								</div>
							) : (
								''
							)}
						</>
					)}
				</div>
			</div>
			<SuccessModal
				getRef={(r) => (succesRef.current = r)}
				onConfirm={() => onClose()}
			/>
			<ErrorModal getRef={(r) => (errorRef.current = r)} />
		</Modal>
	)
}

export default memo(UpdateUserModal)
